import { jsxs as g, jsx as r } from "react/jsx-runtime";
import * as u from "react";
import { cn as o } from "../../../lib/utils.js";
const h = u.forwardRef(({ src: l, alt: s, fallback: n, size: t = "md", status: e, className: a, ...i }, d) => {
  const m = {
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-12 w-12 text-base",
    xl: "h-16 w-16 text-lg"
  }[t], c = {
    online: "bg-lpr-green",
    away: "bg-lpr-gold",
    busy: "bg-lpr-red",
    offline: "bg-text-secondary"
  }[e ?? "offline"], f = {
    sm: "h-2 w-2",
    md: "h-2.5 w-2.5",
    lg: "h-3 w-3",
    xl: "h-3.5 w-3.5"
  }[t];
  return g("div", { ref: d, className: o("relative inline-flex shrink-0 rounded-full border border-border-color bg-bg-muted text-text-primary font-semibold items-center justify-center", m, a), style: { overflow: "visible" }, ...i, children: [l ? r("img", { src: l, alt: s, className: "h-full w-full object-cover rounded-full", onError: (b) => b.currentTarget.style.display = "none" }) : r("span", { children: n }), e && r("span", { className: o("absolute -bottom-0.5 -right-0.5 z-10 rounded-full ring-2 ring-bg-surface shadow-card", c, f, e === "online" && "animate-pulse-dot") })] });
});
h.displayName = "Avatar";
export {
  h as Avatar
};
//# sourceMappingURL=Avatar.js.map
